import { createVNode as _createVNode } from "vue";
import { defineComponent } from 'vue';
import { useStyleConfig } from '../abstract';
import { VcCheckboxGroup } from '../vc-checkbox';
export default defineComponent({
  name: 'ImgCheckboxGroup',
  extends: VcCheckboxGroup,
  data: function data() {
    var _useStyleConfig = useStyleConfig('img-checkbox-group'),
      prefixCls = _useStyleConfig.prefixCls;
    return {
      prefixCls: prefixCls
    };
  },
  render: function render() {
    var _this$$slots, _this$$slots$default;
    var prefixCls = this.prefixCls;
    var items = (_this$$slots = this.$slots) === null || _this$$slots === void 0 ? void 0 : (_this$$slots$default = _this$$slots.default) === null || _this$$slots$default === void 0 ? void 0 : _this$$slots$default.call(_this$$slots);
    var itemList = this.filterItem(items, 'ImgCheckbox');
    return _createVNode("div", {
      "class": "".concat(prefixCls)
    }, [itemList]);
  }
});